import { useEffect, useState } from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Alert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/Button';
import { Link } from "react-router-dom";
import { ventrisConfig } from '../ventris.config';
import AsyncStatus from '../components/AsyncStatus';

import logo from '../assets/img/logo.jpg';

function SsoCallback() {
  const [error, setError] = useState("");

  useEffect(() => {
    const completeSsoLogin = async () => {
      try {
        const params = new URLSearchParams(window.location.search);
        const hashParams = new URLSearchParams(window.location.hash.replace(/^#/, ""));
        const code = params.get("code");
        const state = params.get("state");
        const errorCode = params.get("error");
        const errorDescription = params.get("error_description");
        const accessToken = hashParams.get("access_token");

        if (errorCode) {
          setError(errorDescription || "SSO sign in was cancelled or failed.");
          return;
        }

        if (!state || (!code && !accessToken)) {
          setError("Missing SSO callback data. Please start sign in again.");
          return;
        }

        const response = await fetch(ventrisConfig.url + '/api/sso/authenticate', {
          method: 'post',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            code: code,
            state: state,
            access_token: accessToken
          })
        });

        const data = await response.json();
        if (!data.success || !data.token) {
          setError(data.message || "Unable to sign in with SSO. Please try again.");
          return;
        }

        const token = data.token;
        sessionStorage.setItem("token", token);

        const accountResponse = await fetch(ventrisConfig.url + '/api/account', {
          method: 'get',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
          }
        });

        const accountData = await accountResponse.json();
        sessionStorage.setItem("portal", accountData.role.toLowerCase());
        sessionStorage.setItem("current_user", JSON.stringify(accountData));
        document.location.href = "/";
      } catch (callbackError) {
        console.error(callbackError);
        setError("Unable to complete SSO sign in. Please try again.");
      }
    };

    completeSsoLogin();
  }, []);

  return (
    <Container fluid as="main" id="main-content" tabIndex={-1} className="login-wrapper" aria-busy={error === ""}>
      <AsyncStatus busy={error === ""} busyMessage="Completing SSO sign in." />
      <Row className="login-row">
        <Col className="login-card">
          <div className="login-card-inner">
            <div className="login-card-header">
              <img src={logo} alt="Ventris Learning Logo" className="login-logo" />
            </div>
            <div className="login-card-divider" />
            <div className="login-card-body">
              <h1 className="login-title">Completing SSO Sign In</h1>
              <p className="login-subtitle">Please wait while we sign you in.</p>
              {error !== "" ? (
                <>
                  <Alert variant="danger" className="login-error login-error-block">{error}</Alert>
                  <div className="login-actions">
                    <Link className="login-btn-secondary" to="/">
                      Return to Login
                    </Link>
                  </div>
                </>
              ) : (
                <div className="login-actions">
                  <Button type="button" className="login-btn-primary" disabled>
                    Please wait...
                  </Button>
                </div>
              )}
            </div>
            <div className="login-card-divider" />
            <div className="login-card-footer">
              <span className="login-help-text">
                <strong>Need help?</strong> Contact us by email at{" "}
                <a className="login-help-link" href="mailto:help@ventrislearning.com">help@ventrislearning.com</a>{" "}
                or by phone at{" "}
                <a className="login-help-link" href="tel:800-555-1234">800-555-1234</a>.
              </span>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default SsoCallback;
